import { render, staticRenderFns } from "./NuevaGeocerca.vue?vue&type=template&id=4871c83e&scoped=true"
import script from "./NuevaGeocerca.vue?vue&type=script&setup=true&lang=js"
export * from "./NuevaGeocerca.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NuevaGeocerca.vue?vue&type=style&index=0&id=4871c83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871c83e",
  null
  
)

export default component.exports